<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submit")

        // First name field
        v-text-field(
            name="firstName"
            :label="$t('fields.firstName')"
            type="firstName"
            v-model="model.firstName"
            v-validate="'required'"
            :data-vv-as="$t('fields.firstName')"
            :error-messages="errors.collect('firstName')"
            outlined
        )

        // Last name field
        v-text-field(
            name="lastName"
            :label="$t('fields.lastName')"
            type="lastName"
            v-model="model.lastName"
            v-validate="'required'"
            :data-vv-as="$t('fields.lastName')"
            :error-messages="errors.collect('lastName')"
            outlined
        )

        // Email field
        v-text-field(
            name="email"
            :label="$t('fields.email')"
            type="email"
            v-model="model.email"
            v-validate="'required|email'"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('email')"
            outlined
        )

        // Password field
        v-text-field(
            name="password"
            :label="$t('fields.password')"
            v-model="model.password"
            v-validate="{ required: true, min: 8, max: 24, verifyPassword: true }"
            :data-vv-as="$t('fields.password')"
            :error-messages="errors.collect('password')"
            outlined
            ref="password"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibility = !visibility)"
            :type="visibility ? 'text' : 'password'"
        )

        // Password Confirm field
        v-text-field(
            name="confirmPassword"
            v-model="model.confirmPassword"
            :label="$t('fields.confirmPassword')"
            v-model.lazy="model.passwordConfirmation"
            v-validate="{ required: true, min: 8, max:24, is: model.password, verifyPassword: true }"
            :data-vv-as="$t('fields.confirmPassword')"
            :error-messages="errors.collect('confirmPassword')"
            outlined
            data-vv-as="Confirm Password"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibility = !visibility)"
            :type="visibility ? 'text' : 'password'"
        )

        div.d-flex.justify-space-between.align-center
            div
                // Redirect to login page
                | {{ $t('auth.registration.alreadyAMember') }} &nbsp;
                router-link.link(a to="/login") {{ $t('auth.registration.signIn') }}
                | {{ ` or `}}
                router-link.link(a to="/forgot-password") {{ $t('auth.login.link') }}


            div.text-xs-right

                vue-recaptcha(
                    :sitekey="sitekey"
                    @verify="submit"
                )

                    // Submit button
                    v-btn.mr-0.submit(
                        type="submit"
                        color="primary"
                        size="medium"
                        :isLoading="isLoading"
                    ) {{ $t('auth.registration.confirm') }}
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        components: {
            VueRecaptcha,
        },
        data() {
            return {
                model: {
                    email: '',
                    password: '',
                    confirmPassword: '',
                    firstName: '',
                    lastName: '',
                    phone: '',
                    cellPhone: '',
                },
                sitekey: '6Ld07wAVAAAAAOByK2gQhD8OGuAAS4vxWU-EX61l',
                visibility: false,
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading']),
        },
        methods: {
            ...mapActions('auth', ['registration']),

            /**
             * Create user and redirect to confirmation registration page
             */
            async submit(resp) {
                if (!resp) return;
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.registration(this.model);
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .link
        font-size 14px;
</style>
